import * as React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';

import Fields from './Components/Fields';
import Footer from './Components/Footer';

export default class extends React.PureComponent{

  static propTypes = {
    submitting: PropTypes.bool.isRequired,
    caveatId: PropTypes.number,
    componentWillMount: PropTypes.func.isRequired,
    onClickCancel: PropTypes.func.isRequired
  }

  static defaultProps = {
    caveatId: null
  }

  componentWillMount = () => this.props.componentWillMount(this.props);

  render () {

    const {
      submitting,
      caveatId,
      onClickCancel
    } = this.props;

    return (
        
      <Modal
        visible  
        title={`${caveatId ? 'Caveat': 'New Caveat'}`}        
        onCancel={onClickCancel}
        footer={<Footer submitting={submitting} caveatId={caveatId} />}
        width={700}
      >
        
        <Fields submitting={submitting} />

      </Modal>
    )
  }
}